import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  color: string;
  description?: string;
  level: number;
  name: string;
  shape: string;
};
export default { id, query, get, post };
